import ExternalDataWidget from '@/components/Widgets/ExternalData/ExternalDataWidget.vue'
import GaugeChart from '@/components/Charts/FunnelChart/GradeGaugeChart.vue'
import RichTextEditor from '@/components/RedesignComponents/Widgets/RichText/RichTextEditor.vue'
import RichTextListEditor from '@/components/RedesignComponents/Widgets/RichText/RichTextListEditor.vue'
import QueueActiveCall from '@/components/Widgets/Data/Queue/QueueActiveCall.vue'
import StatisticsCards from '@/components/Cards/StatisticsCards.vue'
import SocketsRealTimeFunnel from '@/components/Charts/FunnelChart/FunnelChart.vue'
import RedesignCounterCard from '@/components/RedesignComponents/Cards/CounterCard/RedesignCounterCard.vue'
import AiCounterCard from '@/components/RedesignComponents/Cards/CounterCard/AiCounterCard.vue'
import RedesignQueueCounterCard from '@/components/RedesignComponents/Cards/CounterCard/RedesignQueueCounterCard.vue'
import RedesignTotalOutgoingCalls
    from '@/components/RedesignComponents/Cards/CounterCard/RedesignTotalOutgoingCalls.vue'
import RedesignAvgCallDuration from '@/components/RedesignComponents/Cards/CounterCard/RedesignAvgCallDuration.vue'
import RedesignExtensionCards from '@/components/RedesignComponents/Cards/ExtensionCard/RedesignExtensionCards.vue'
import RedesignTableData from '@/components/RedesignBaseComponents/RedesignTableData.vue'

import Charts from '@/components/RedesignComponents/Charts'
import ExtensionsDashboard from '@/components/RedesignComponents/Cards/ExtensionsDashbordCards/ExtensionsDashboard.vue'
import VoicebotsWidget from '@/components/RedesignComponents/Cards/Voicebots/VoicebotsWidget.vue'
import VoicebotCounterCard from '@/components/RedesignComponents/Cards/CounterCard/VoicebotCounterCard.vue'
import ClockAndDateWidget from '@/components/RedesignComponents/Cards/ClockAndDate/ClockAndDateWidget.vue'
import RedesignQueueDashboard from '@/components/RedesignComponents/Widgets/RedesignQueueDashboard.vue'
import RedesignAiSummaryBullets from '@/components/RedesignComponents/Widgets/RedesignAiSummaryBullets.vue'
import RedesignAiSummaryNumbers from '@/components/RedesignComponents/Widgets/RedesignAiSummaryNumbers.vue'
import RedesignAiSummarySimpleText from '@/components/RedesignComponents/Widgets/RedesignAiSummarySimpleText.vue'
/* Add New Widgets limits */
export const MAX_WIDGETS_WARNING = 15
export const MAX_WIDGETS_LIMIT = 30

/* Add New Widgets modal steps */
export const TEMPLATE_CATEGORIES = 1
export const CATEGORY_PREVIEW = 2
export const TEMPLATES_SETUP = 3
export const SUMMERY_PREVIEW = 4
export const TEMPLATE_HELP_PREVIEW = 5

export const WidgetComponentsEnum = {
    GaugeChart,
    StatisticsCards,
    QueueActiveCall,
    ExternalDataWidget,
    RichTextEditor,
    RichTextListEditor,
    SocketsRealTimeFunnel,
    RedesignExtensionCards,
    RedesignCounterCard,
    AiCounterCard,
    RedesignQueueCounterCard,
    RedesignTotalOutgoingCalls,
    RedesignAvgCallDuration,
    RedesignTableData,
    ExtensionsDashboard,
    VoicebotsWidget,
    VoicebotCounterCard,
    ClockAndDateWidget,
    RedesignQueueDashboard,
    RedesignAiSummaryNumbers,
    RedesignAiSummaryBullets,
    RedesignAiSummarySimpleText,
    ...Charts
}

export const titleCardFontSizes = {
    min: 12,
    max: 150
}
export const valueCardFontSizes = {
    min: 24,
    max: 128
}
export const valueCardMinWidth = {
    min: 24,
    max: 128
}

export const MAXIMUM_RANGE_DEFAULT = 0
